export default "__VITE_ASSET__950b55de__"